jQuery(document).ready(function($) {

	//adds support for IE with the SVG thing, because ie/edge is special
	svg4everybody();
/*
    //Headroom
    $(".headroom").headroom({
      "tolerance": {
        "up": "20",
        "down": "10"
      },
      "classes": {
        "pinned": "slideDown",
        "unpinned": "slideUp"
      }
    });
*/
});

$(document).ready(function() {
	//adds mobile nav toggle
     $('.aoc-top-nav__nav--mobile').click(function() {
        $('.aoc-top-nav').toggleClass('make-visible');
    });
});

$(document).ready(function(){
    if((Liferay.ThemeDisplay.isSignedIn())){
        $('#aoc-pub-header').addClass('showDockbar');
    }
});

$(document).ready(function(){
//set up mutation observer var
//sets for easier cross browser use
//should be set as high as possible in the script, before call for ad server
window.MutationObserver = window.MutationObserver
        || window.WebKitMutationObserver
        || window.MozMutationObserver;
//sets node object of element to be watched, should be before ad server call
var target2 = document.getElementById('aoc-pub-ad-banner');
//sets up observer function, should be called before ad server
observer2 = new MutationObserver(function(mutation) {
        if ($('#aoc-pub-ad-banner a').length == 1) {
            $('#aoc-pub-header').removeClass('aoc-pub-noAds');
        }
    }),
    //must be followed by configuration of the observer:
    configObj = {
        attributes: true, childList: true, characterData: true // this is to watch for attribute and content changes.
    };

//starts observing node, should be before ad server call
observer2.observe(target2, configObj);
    // later, you can stop observing
    // observer2.disconnect();
});

/* slick slider photo gallery, resolves issue that show up as empty thumbnails */
/* because thumbnail haven't been generated by liferay, script waits half a second, swaps out styles, with no styles then reattaches styles */
window.addEventListener("load", (event) => {
    setTimeout(function(){
        $(".aoc-pub-image-slider__tabs--img").each(function(){
            srcRepeater=$(this).attr("style");
            $(this).attr("style","");
            $(this).attr("style",srcRepeater);
        });},500);

});
// for sticky header 74 upgrade
// the jquery on load function was not waiting for the ads to load
window.addEventListener("load", (event) => {
    // added to give sticky effect for classifieds left column
    $(".journal-content-article:has(.service-directory)").css("height", $("#column-4").height()-($(".service-directory").height()/4));
    $(window).on('resize', function(){
        $(".journal-content-article:has(.service-directory)").css("height", $("#column-4").height()-$(".service-directory").height()/4);
    });


    (function($) {
        $(document).ready(function(){
            if($(".aoc-pub-ad-banner a").length == 0){
                //alert("no ad")
                $('#aoc-pub-header').addClass('aoc-pub-noAds');
            }else{
                //alert("ad");
            }
        });
    })(jQuery);

    function socialLinks(){
        uri=window.location;
        uri=uri.toString();

        enc=encodeURIComponent(uri);
        prtitle="${Book_Title.getData()}";
        prtitle=encodeURI(prtitle);
        //alert(enc);

        //Twitter
        $("#aoc-sticky-twitter").attr("href","https://twitter.com/intent/tweet?url="+enc+"&amp;text="+prtitle+"&amp;via=CatholicNewsSvc");
        $("#aoc-mobile-twitter").attr("href","https://twitter.com/intent/tweet?url="+enc+"&amp;text="+prtitle+"&amp;via=CatholicNewsSvc");

        //Facebook
        $("#aoc-sticky-facebook").attr("href","https://www.facebook.com/sharer/sharer.php?u="+enc);
        $("#aoc-mobile-facebook").attr("href","https://www.facebook.com/sharer/sharer.php?u="+enc);
    }
    // test if sticky social media links exist
    if($("#aoc-pub-social-media-sticky").length > 0){
        $(document).ready(function(){
            // Sticky element for Article Page
            $("#aoc-pub-social-media-sticky").sticky({topSpacing:0});

            // Sticky element for Book Detail
            $("#aoc-pub-social-media-books-sticky").sticky({topSpacing:0});

            // Sticky element for Events Side Nav
            $('#aoc-pub-events-nav-sticky').sticky({topSpacing:100});

            socialLinks();
        });
    }

});
